import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { stateFactories, actionsHandlers } from 'store/features/utils';
import * as actions from '../actions';

const stateFactory = stateFactories.createInitialSingleFeatureStateFactory();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const conflictResolveReducer = createReducer<State, Actions>(initialState, {
  [actions.deeplinkConflictResolve.request.type]: actionsHandlers.handleSingleFeatureRequest,
  [actions.deeplinkConflictResolve.success.type]: actionsHandlers.handleSingleFeatureSuccess,
  [actions.deeplinkConflictResolve.failure.type]: actionsHandlers.handleSingleFeatureFailure,
  [actions.deeplinkConflictResolve.reset.type]: actionsHandlers.handleSingleFeatureReset,
});

export default conflictResolveReducer;
